<template>
    <div class="container">
        <div class="member-register">
            <h1 class="page_h1">{{registerClassName}}註冊</h1>
            <div class="form f-row">
                <div class="register_step">
                    <h4 class="register_title">Step 1</h4>
                    <p class="register_txt">請於手機簡訊接收驗證碼，並填入下方欄位（非台灣用戶請加入國際碼）</p>
                    <p class="register_txt">例 馬來西亞用戶 012xxxx666 => 6012xxxx666</p>
                </div>
                <formInupt label="手機號碼" v-model="req.phone" :error="error.phone" />
                <div class="form_grp f-col@lg:auto align:r mg-t-12">
                    <button class="btn w:full clr:primary" @click="onclick">繼續</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import Validator from "../../../libs/Validator";
import formInupt from '../../../components/form/input.vue'
import Response from "../../../libs/Response";
import {mapGetters, mapState} from "vuex";

export default {
    name: 'member-register',
    components: {
        formInupt,
    },
    data(){
        return {
            req:{
                phone:'',
            },
            error:{
                phone:'',
            },
        }
    },
    mounted() {
        if(!this.$store.state.parentClass){
            window.location = '/'
        }
    },
    methods:{
        async onclick(){
            const vm = this
            try{
                const validator = Validator.make(vm.req,{
                    phone:['required','min:10','max:10','phone']
                })
                if (validator.fails()) {
                    console.log(validator._errors)
                    throw Response.create(validator.errors())
                }
                this.$store.commit('setLoadingStatus',true)
                const res = await vm.$axios.post('/api/register/step1', vm.req);
                this.$store.commit('setLoadingStatus',false)
                vm.$router.push({name:'register2',params:{token:res.data.token}});

            }catch (e) {
                this.$store.commit('setLoadingStatus',false)
                vm.error = e.response.data
            }

        }
    },
    computed:{
        ...mapState([
            'parentClass'
        ]),
        ...mapGetters([
            'registerClassName'
        ])
    }
}
</script>

<style lang="scss" scoped>
.router_link {
    font-size: 0.875rem;
}
.reset-mg\:b {
    margin-bottom: 0.75rem;
}
</style>
